// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Asistent',
  },
  close: {
    amigo: 'Închide Amigo',
    assistant: 'Închide asistentul',
  },
  brand: 'Brand',
  // No restaurant selected in the dashboard (D18): the header's line.
  no_restaurant: 'Niciun restaurant selectat',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Conversații',
  new_chat: 'Conversație nouă',
  back: 'Înapoi la conversație',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Răspunsuri noi într-un alt chat',
  news_elsewhere_few: 'Răspunsuri noi în alte {{count}} chaturi',
  news_elsewhere_other: 'Răspunsuri noi în alte {{count}} chaturi',
};
